import {
  Component,
  ElementRef, EventEmitter,
  HostListener, Inject,
  Input,
  OnChanges,
  OnDestroy, Output,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { interval, Subscription } from 'rxjs';
import { DATA_TRANSFER_HELPER } from "../../../../helper/dataTransfer.helper";

@Component({
  selector: 'fi-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  standalone: false,
})
export class SearchComponent implements OnDestroy, OnChanges {
  @ViewChild('searchInput') searchInput: ElementRef;
  @ViewChild('searchFilterContainer') searchFilterContainer: ElementRef;
  @Input() isActive: boolean;
  @Input() displayInMobile: boolean;
  @Input() isMobile: boolean;
  @Input() value = '';
  @Output() searchChanged = new EventEmitter<string>();
  @Output() mobileSearchClicked = new EventEmitter<void>();

  private static lastTimeSearched = false;

  private $subscription: Subscription;
  searchedString: string;
  isOpened = false;

  constructor(
    @Inject(DATA_TRANSFER_HELPER) private dataTransfer,
  ) {
    this.setSearchContainerForMobileOrDisplay();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value) {
      this.setSearchValue(this.value ?? '');
    }
  }

  @HostListener('window:resize', [])
  resize(): void {
    this.showOrHideSearchContainer();
  }

  debounceSearch(): void | boolean {
    return !!this.searchInput?.nativeElement;
  }

  ngOnDestroy(): void {
    this.$subscription?.unsubscribe();
  }

  private get searchText(): string {
    return this.searchInput?.nativeElement?.value?.trim() ?? '';
  }

  clearInputText(): void {
    if (this.searchInput?.nativeElement?.value) {
      this.searchInput.nativeElement.value = '';
      this.searchChanged.emit('');
    }
  }

  private setSearchValue(value: string): void {
    this.searchedString = value;

    if (this.searchInput?.nativeElement instanceof HTMLInputElement) {
      this.searchInput.nativeElement.value = value;
    }
  }

  onSearchSubmit(event: Event): void {
    event.preventDefault();
    this.searchChanged.emit(this.searchText);
    this.closeOverlay(event);
    this.toggleCalendar(false);
  }

  onMobileSearchPointerDown(event: PointerEvent): void {
    if (!this.isMobile) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    this.mobileSearchClicked.emit();
    this.searchInput?.nativeElement?.blur();
  }

  onClickSearch(): void {
    if (this.isMobile) {
      return;
    }

    this.isOpened = true;
    setTimeout(() => {
      window.scrollTo({
        top: -110
      });
    }, 500);
  }

  closeOverlay($event): void {
    $event.stopPropagation();
    this.searchInput?.nativeElement?.blur();
    this.isOpened = false;
  }

  private showOrHideSearchContainer(): void {
    if (this.displayInMobile) {
      this.searchFilterContainer?.nativeElement?.classList?.add('show');
    } else {
      this.searchFilterContainer?.nativeElement?.classList?.remove('show');
    }
  }

  private setSearchContainerForMobileOrDisplay(): void {
    let showOrHideSearchContainer = interval(1000).subscribe(() => {
      this.showOrHideSearchContainer();
      showOrHideSearchContainer?.unsubscribe();
    });

    let debounceSearch = interval(1000).subscribe(() => {
      let done = this.debounceSearch();
      if (done) {
        debounceSearch?.unsubscribe();
      }
    });
  }

  toggleCalendar(b: boolean): void {
    this.dataTransfer.setData(b)
  }

  @HostListener('window:click', ['$event'])
  outClick(event: MouseEvent): void {
    if (
      (event.target as HTMLElement)?.classList?.contains('search-container') ||
      (event.target as HTMLElement)?.classList?.contains('search-input') ||
      (event.target as HTMLElement)?.classList?.contains('search-field')
    ) {
      return;
    }
    this.closeOverlay(event);
    this.dataTransfer.setData(false)
  }
}
